import React, { useState ,useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useLocation } from 'react-router-dom';
import { faArrowLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Bhimupi from './images/Bhimupi.png';
import Cash from './images/Cash.png';
import ArrowLeft from './images/ArrowLeft.png';
import Header from './Component/Header1';

const PaymentMethod = ({ onBack, onContinue }) => {
  const [selected, setSelected] = useState('upi');
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get quotation data from location state
  const { rfq_id, quotationData, totalAmount, quotationId, quotationNumber } = location.state || {};



  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
     
        <Header
  title="Payment Method"
  showSearch={false}
  backPath="/consumer/app/rfqdetails"
  backState={{ rfq_id: rfq_id }}
/>

      {/* UPI Payment Option */}
      <div
        className={`flex items-center justify-between border rounded-xl bg-white px-4 py-2 mt-6 mx-6 cursor-pointer ${
          selected === 'upi' ? 'border-gray-200' : 'border-gray-200'
        }`}
        onClick={() => {
          setSelected('upi');
          navigate('/consumer/upipayments', {
            state: {
              rfq_id: rfq_id,
              quotationData: quotationData,
              totalAmount: totalAmount,
              quotationId: quotationId,
              quotationNumber: quotationNumber
            }
          }); 
        }}
      >
        <div className="flex items-center">
          <img src={Bhimupi} alt="UPI" className="w-8 h-8 mr-3" />
          <div>
            <div className="font-bold text-sm text-[#524D4D]">UPI Payments</div>
            <div className="text-xs text-[#524D4D]">Faster way to pay money</div>
          </div>
        </div>
        <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 text-xs" />
      </div>

      {/* Cash on Delivery Option */}
      <div
        className={`flex items-center justify-between border rounded-xl bg-white px-4 py-2 mt-4 mx-6 cursor-pointer ${
          selected === 'cash' ? 'border-gray-200' : 'border-gray-200'
        }`}
        onClick={() => setSelected('cash')}
      >
        <div className="flex items-center">
          <img src={Cash} alt="Cash" className="w-8 h-8 mr-3" />
          <div>
            <div className="font-bold text-sm text-[#524D4D]">Cash on Delivery</div>
            <div className="text-xs text-[#524D4D]">Pay in Cash after Product is delivered.</div>
          </div>
        </div>
        <input
          type="radio"
          checked={selected === 'cash'}
          onChange={() => setSelected('cash')}
          className="w-5 h-5 text-red-500 border-gray-300"
          style={{
            accentColor: '#ef4444'
          }}
        />
      </div>

      {/* Continue Button */}
      <div className="fixed bottom-0 left-0 right-0 bg-white px-4 py-4 z-50">
        <button
          className="w-full py-3 bg-[#F43042] text-white rounded-md font-semibold text-sm"
          onClick={() => onContinue && onContinue(selected)}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default PaymentMethod;
